var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path, _path2, _path3, _path4, _g9, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopMd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 565,
    height: 544,
    viewBox: "0 0 565 544",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.394 124.866L166.61 146.651L77.4268 94.9112L116.572 73.126L204.394 124.866Z",
    stroke: "white",
    strokeWidth: 1.6695,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.394 239.919L166.61 261.704L77.4268 209.964L116.572 188.179L204.394 239.919Z",
    stroke: "white",
    strokeWidth: 1.6695,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.18 239.919L166.396 261.704L77.2129 209.964L116.358 188.179L204.18 239.919Z",
    stroke: "white",
    strokeWidth: 1.6695,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.61 146.651V261.705",
    stroke: "white",
    strokeWidth: 1.6695,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.914 73.126V188.179L77.4658 209.927V94.8734",
    stroke: "white",
    strokeWidth: 1.6695,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.396 124.488V239.541",
    stroke: "white",
    strokeWidth: 1.6695,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.181 167.378L91.3971 189.163L2.21387 137.423L41.3592 115.638L129.181 167.378Z",
    stroke: "white",
    strokeWidth: 1.66948,
    strokeMiterlimit: 10,
    strokeDasharray: "5.53 5.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.181 282.431L91.3971 304.217L2.21387 252.477L41.3592 230.691L129.181 282.431Z",
    stroke: "#231F20",
    strokeWidth: 1.66948,
    strokeMiterlimit: 10,
    strokeDasharray: "5.53 5.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.967 282.431L91.1833 304.217L2 252.477L41.1453 230.691L128.967 282.431Z",
    stroke: "white",
    strokeWidth: 1.66948,
    strokeMiterlimit: 10,
    strokeDasharray: "5.53 5.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3975 189.163V304.216",
    stroke: "white",
    strokeWidth: 1.66948,
    strokeMiterlimit: 10,
    strokeDasharray: "5.53 5.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7008 115.638V230.691L2.25293 252.438V137.385",
    stroke: "white",
    strokeWidth: 1.66948,
    strokeMiterlimit: 10,
    strokeDasharray: "5.53 5.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.184 167V282.053",
    stroke: "white",
    strokeWidth: 1.66948,
    strokeMiterlimit: 10,
    strokeDasharray: "5.53 5.53"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.299 182.392L407.515 204.177L318.332 152.438L357.477 130.652L445.299 182.392Z",
    stroke: "white",
    strokeWidth: 1.6695,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.299 297.445L407.515 319.23L318.332 267.49L357.477 245.705L445.299 297.445Z",
    stroke: "white",
    strokeWidth: 1.6695,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.085 297.445L407.301 319.23L318.118 267.49L357.263 245.705L445.085 297.445Z",
    stroke: "white",
    strokeWidth: 1.6695,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.516 204.178V319.231",
    stroke: "white",
    strokeWidth: 1.6695,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.818 130.652V245.706L318.37 267.453V152.4",
    stroke: "white",
    strokeWidth: 1.6695,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.302 182.015V297.068",
    stroke: "white",
    strokeWidth: 1.6695,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M562.379 247.306L524.595 269.092L435.412 217.352L474.557 195.566L562.379 247.306Z",
    stroke: "white",
    strokeWidth: 1.66948,
    strokeMiterlimit: 10,
    strokeDasharray: "5.53 5.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.379 362.359L524.595 384.144L435.412 332.404L474.557 310.619L562.379 362.359Z",
    stroke: "#231F20",
    strokeWidth: 1.66948,
    strokeMiterlimit: 10,
    strokeDasharray: "5.53 5.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.165 362.359L524.382 384.144L435.198 332.404L474.344 310.619L562.165 362.359Z",
    stroke: "white",
    strokeWidth: 1.66948,
    strokeMiterlimit: 10,
    strokeDasharray: "5.53 5.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.596 269.092V384.145",
    stroke: "white",
    strokeWidth: 1.66948,
    strokeMiterlimit: 10,
    strokeDasharray: "5.53 5.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.899 195.566V310.62L435.451 332.367V217.314",
    stroke: "white",
    strokeWidth: 1.66948,
    strokeMiterlimit: 10,
    strokeDasharray: "5.53 5.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.382 246.929V361.982",
    stroke: "white",
    strokeWidth: 1.66948,
    strokeMiterlimit: 10,
    strokeDasharray: "5.53 5.53"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.115 104.579L272.899 126.364L362.082 74.6241L322.937 52.8389L235.115 104.579Z",
    stroke: "white",
    strokeWidth: 1.6695,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.115 219.632L272.899 241.417L362.082 189.677L322.937 167.892L235.115 219.632Z",
    stroke: "white",
    strokeWidth: 1.6695,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.329 219.632L273.113 241.417L362.296 189.677L323.151 167.892L235.329 219.632Z",
    stroke: "white",
    strokeWidth: 1.6695,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.898 126.364V241.417",
    stroke: "white",
    strokeWidth: 1.6695,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.597 52.8389V167.892L362.045 189.64V74.5863",
    stroke: "white",
    strokeWidth: 1.6695,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.115 104.201V219.254",
    stroke: "white",
    strokeWidth: 1.6695,
    strokeMiterlimit: 10
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.963 52.7399L189.747 74.5251L278.93 22.7852L239.785 1L151.963 52.7399Z",
    stroke: "white",
    strokeWidth: 1.66948,
    strokeMiterlimit: 10,
    strokeDasharray: "5.53 5.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.963 167.794L189.747 189.579L278.93 137.839L239.785 116.054L151.963 167.794Z",
    stroke: "#231F20",
    strokeWidth: 1.66948,
    strokeMiterlimit: 10,
    strokeDasharray: "5.53 5.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.177 167.794L189.961 189.579L279.144 137.839L239.998 116.054L152.177 167.794Z",
    stroke: "white",
    strokeWidth: 1.66948,
    strokeMiterlimit: 10,
    strokeDasharray: "5.53 5.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.746 74.5254V189.579",
    stroke: "white",
    strokeWidth: 1.66948,
    strokeMiterlimit: 10,
    strokeDasharray: "5.53 5.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.444 1V116.053L278.892 137.801V22.7474",
    stroke: "white",
    strokeWidth: 1.66948,
    strokeMiterlimit: 10,
    strokeDasharray: "5.53 5.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.963 52.3623V167.416",
    stroke: "white",
    strokeWidth: 1.66948,
    strokeMiterlimit: 10,
    strokeDasharray: "5.53 5.53"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.79 406.134L278.574 427.92L367.757 376.18L328.612 354.395L240.79 406.134Z",
    stroke: "white",
    strokeWidth: 1.66948,
    strokeMiterlimit: 10,
    strokeDasharray: "5.53 5.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.79 521.187L278.574 542.972L367.757 491.232L328.612 469.447L240.79 521.187Z",
    stroke: "#231F20",
    strokeWidth: 1.66948,
    strokeMiterlimit: 10,
    strokeDasharray: "5.53 5.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.004 521.187L278.788 542.972L367.971 491.232L328.826 469.447L241.004 521.187Z",
    stroke: "white",
    strokeWidth: 1.66948,
    strokeMiterlimit: 10,
    strokeDasharray: "5.53 5.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.573 427.92V542.973",
    stroke: "white",
    strokeWidth: 1.66948,
    strokeMiterlimit: 10,
    strokeDasharray: "5.53 5.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.271 354.395V469.448L367.719 491.195V376.142",
    stroke: "white",
    strokeWidth: 1.66948,
    strokeMiterlimit: 10,
    strokeDasharray: "5.53 5.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.79 405.757V520.81",
    stroke: "white",
    strokeWidth: 1.66948,
    strokeMiterlimit: 10,
    strokeDasharray: "5.53 5.53"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.61 354.532L204.394 376.317L293.577 324.577L254.432 302.792L166.61 354.532Z",
    stroke: "white",
    strokeWidth: 1.6695,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.61 469.585L204.394 491.37L293.577 439.63L254.432 417.845L166.61 469.585Z",
    stroke: "white",
    strokeWidth: 1.6695,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.825 469.585L204.609 491.37L293.792 439.63L254.647 417.845L166.825 469.585Z",
    stroke: "white",
    strokeWidth: 1.6695,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.395 376.317V491.371",
    stroke: "white",
    strokeWidth: 1.6695,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.092 302.792V417.845L293.54 439.593V324.539",
    stroke: "white",
    strokeWidth: 1.6695,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.61 354.154V469.208",
    stroke: "white",
    strokeWidth: 1.6695,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M221.346 261.797C212.461 265.913 209.896 264.867 200.604 268.158C195.766 269.872 188.17 272.562 180.691 278.668C174.558 283.673 168.035 288.998 167.416 297.474C166.873 304.892 171.061 311.861 175.989 315.727C180.543 319.3 184.227 319.046 195.625 321.535C195.626 321.535 205.632 323.72 216.644 327.343C234.735 333.295 235.098 338.935 254.257 346.15C264.323 349.94 270.986 352.352 279.701 350.851C281.739 350.5 292.902 348.578 299.614 339.512C300.594 338.188 301.755 335.569 304.039 330.385C309.181 318.71 311.752 312.872 311.506 309.92C310.911 302.786 305.073 297.96 297.124 291.39C292.499 287.567 288.141 285.246 279.424 280.604C271.484 276.375 267.436 274.255 263.66 273.966C262.08 273.845 258.434 273.751 253.704 272.307C253.704 272.307 251.389 271.6 249.279 270.647C239.671 266.31 237.781 258.207 231.579 257.372C228.749 256.991 228.32 258.567 221.346 261.797Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M416.678 386.528C411.982 390.881 407.423 389.932 400.638 392.059C396.841 393.25 386.673 396.438 384.597 403.952C383.124 409.282 385.962 415.927 390.958 419.163C397.072 423.122 405.214 421.194 409.764 417.503C416.449 412.081 413.935 404.025 420.827 400.356C424.376 398.467 425.58 400.317 430.783 398.42C436.842 396.212 443.972 390.509 442.952 385.698C442.088 381.622 435.708 379.774 432.719 379.337C426.93 378.492 422.402 381.268 420.827 382.38C418.636 383.927 418.51 384.831 416.678 386.528Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M381.001 346.151C379.181 350.584 385.047 353.638 385.426 361.639C385.607 365.453 384.347 366.29 379.342 377.679C375.328 386.813 372.705 392.859 371.045 400.358C369.888 405.58 368.878 410.145 369.385 415.845C370.143 424.359 374.737 440.487 387.085 444.055C398.581 447.376 410.085 437.873 411.976 436.311C416.275 432.76 420.359 427.457 422.486 424.695C428.009 417.524 427.869 415.676 431.336 413.633C435.339 411.273 439.621 411.323 447.93 411.42C455.996 411.515 456.926 412.658 459.545 411.42C465.121 408.786 468.191 400.165 466.736 393.167C465.062 385.118 457.738 380.83 452.355 377.679C445.056 373.407 436.963 371.367 424.698 368.276C418.005 366.589 415.138 366.184 412.53 363.298C408.561 358.908 410.728 354.903 406.445 348.917C405.601 347.736 401.667 342.238 394.829 341.173C389.79 340.388 382.73 341.941 381.001 346.151Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M404.647 371.041C401.192 372.395 401.612 374.91 395.658 380.444C391.221 384.569 390.373 383.743 386.67 387.358C384.254 389.717 380 393.87 378.373 400.495C376.925 406.39 378.294 411.236 379.479 415.43C380.691 419.719 381.627 423.031 384.734 425.801C388.779 429.408 393.781 429.602 395.52 429.673C405.986 430.097 413.478 422.011 414.05 421.376C419.136 415.719 417.729 411.818 423.176 408.101C424.007 407.534 424.409 407.373 433.133 404.644C444.053 401.228 446.255 400.595 448.482 398.144C449.272 397.275 451.764 394.452 451.939 390.262C452.137 385.526 449.239 382.209 448.344 381.274C446.349 379.19 443.967 378.143 439.217 376.987C429.257 374.563 427.431 376.172 419.305 374.36C410.286 372.349 408.604 369.49 404.647 371.041Z",
    fill: "white"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M511.021 405.847L390.944 475.08L107.519 310.651L231.923 241.417L511.021 405.847Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M207.589 273.352C198.545 275.931 193.934 277.264 189.612 279.436C182.38 283.07 178.47 285.035 176.891 289.392C174.652 295.567 178.489 302.688 182.422 306.539C188.299 312.295 196.187 312.509 200.398 312.624C214.996 313.02 218.284 304.903 229.714 306.816C236.678 307.981 235.195 310.949 246.861 315.113C254.271 317.757 264.123 321.121 272.858 316.772C274.473 315.969 278.723 313.778 280.879 309.028C284.558 300.924 278.87 292.564 278.39 291.881C275.183 287.322 270.794 285.439 268.987 284.691C262.552 282.027 259.766 284.203 246.861 282.755C241.626 282.167 239.009 281.874 236.628 280.819C229.07 277.469 228.976 272.181 223.077 270.309C221.933 269.946 220.469 269.679 207.589 273.352Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M216.443 282.402C207.416 279.718 199.369 284.105 198.466 284.615C195.916 286.055 193.077 287.659 192.658 290.423C192.062 294.365 196.712 298.554 200.955 300.103C205.98 301.936 210.911 300.241 215.337 298.72C222.74 296.175 223.499 293.484 228.335 293.465C231.108 293.454 233.595 294.61 238.568 296.922C246.109 300.428 247.915 302.956 251.705 302.315C253.975 301.931 256.735 300.448 257.098 298.305C257.454 296.2 255.358 294.287 254.609 293.603C252.73 291.888 250.67 291.215 242.164 289.87C236.101 288.911 235.335 288.966 232.345 288.21C229.476 287.485 227.216 286.684 225.293 285.998C219.278 283.851 219.139 283.204 216.443 282.402Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M412.125 399.822C410.932 399.484 410.039 399.231 409.058 398.953C410.899 395.954 412.684 393.045 414.541 390.019C413.592 389.781 412.808 389.584 411.892 389.354C413.611 386.156 415.295 383.021 417.055 379.747C415.985 379.59 415.099 379.46 413.901 379.284C417.712 373.902 419.924 367.886 422.221 361.547C424.614 367.815 426.701 373.889 430.622 379.281C429.423 379.452 428.51 379.582 427.415 379.738C429.17 382.983 430.85 386.093 432.606 389.34C431.739 389.56 430.962 389.756 429.932 390.016C431.784 393.024 433.585 395.952 435.439 398.964C434.426 399.245 433.531 399.494 432.361 399.819C434.704 403.158 436.956 406.367 439.422 409.882H424.667V421.489H419.863V409.965H405.009C407.497 406.419 409.75 403.207 412.125 399.822Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 3.33899,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M380.642 417.594C378.632 417.024 377.128 416.598 375.477 416.13C378.577 411.079 381.583 406.181 384.711 401.085C383.113 400.683 381.792 400.351 380.249 399.964C383.144 394.577 385.981 389.299 388.945 383.784C387.142 383.519 385.651 383.3 383.633 383.003C390.051 373.939 393.777 363.808 397.645 353.131C401.676 363.687 405.19 373.917 411.794 383C409.774 383.287 408.237 383.506 406.394 383.768C409.348 389.234 412.179 394.471 415.136 399.941C413.676 400.31 412.367 400.641 410.633 401.079C413.751 406.146 416.785 411.076 419.907 416.149C418.201 416.623 416.694 417.041 414.723 417.589C418.669 423.213 422.461 428.617 426.616 434.537H401.764V454.087H393.674V434.678H368.656C372.846 428.705 376.642 423.295 380.642 417.594Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 3.33899,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M317.489 289.603C315.478 289.033 313.975 288.607 312.323 288.139C315.423 283.088 318.43 278.189 321.557 273.093C319.959 272.692 318.638 272.36 317.096 271.973C319.991 266.586 322.828 261.307 325.792 255.793C323.988 255.528 322.498 255.309 320.48 255.012C326.898 245.947 330.624 235.816 334.492 225.14C338.522 235.696 342.037 245.926 348.64 255.008C346.621 255.296 345.083 255.515 343.24 255.777C346.195 261.243 349.026 266.48 351.983 271.95C350.523 272.319 349.214 272.65 347.479 273.088C350.597 278.154 353.632 283.085 356.754 288.158C355.048 288.631 353.541 289.05 351.57 289.598C355.516 295.221 359.308 300.626 363.462 306.546H338.611V326.096H330.52V306.686H305.503C309.693 300.714 313.489 295.304 317.489 289.603Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 3.33899,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M299.181 322C297.987 321.661 297.095 321.408 296.114 321.13C297.955 318.131 299.74 315.223 301.597 312.197C300.648 311.959 299.864 311.762 298.948 311.532C300.667 308.333 302.351 305.199 304.111 301.925C303.04 301.768 302.155 301.637 300.957 301.461C304.768 296.079 306.98 290.064 309.276 283.725C311.67 289.992 313.757 296.067 317.677 301.459C316.478 301.63 315.565 301.76 314.471 301.916C316.225 305.161 317.906 308.27 319.662 311.518C318.795 311.737 318.018 311.934 316.988 312.194C318.839 315.202 320.641 318.13 322.495 321.142C321.482 321.423 320.587 321.671 319.416 321.997C321.76 325.336 324.011 328.544 326.478 332.059H311.722V343.667H306.919V332.143H292.064C294.552 328.597 296.806 325.385 299.181 322Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 3.33899,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M206.667 272.886C204.902 272.385 203.581 272.011 202.131 271.6C204.853 267.164 207.493 262.862 210.24 258.386C208.837 258.034 207.677 257.743 206.322 257.402C208.865 252.671 211.356 248.035 213.959 243.192C212.375 242.96 211.066 242.767 209.294 242.507C214.93 234.546 218.203 225.648 221.6 216.271C225.14 225.542 228.226 234.527 234.026 242.503C232.252 242.756 230.902 242.948 229.283 243.179C231.878 247.979 234.364 252.578 236.961 257.382C235.679 257.706 234.529 257.997 233.006 258.382C235.744 262.831 238.409 267.161 241.151 271.617C239.653 272.033 238.33 272.4 236.598 272.881C240.064 277.82 243.394 282.566 247.043 287.766H225.218V304.935H218.112V287.889H196.141C199.821 282.644 203.154 277.893 206.667 272.886Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 3.33899,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M181.114 283.457C179.103 282.888 177.6 282.462 175.948 281.993C179.048 276.942 182.055 272.044 185.182 266.948C183.584 266.546 182.263 266.215 180.721 265.827C183.616 260.44 186.453 255.162 189.417 249.647C187.613 249.382 186.123 249.163 184.105 248.867C190.523 239.802 194.249 229.671 198.117 218.994C202.147 229.55 205.662 239.781 212.265 248.863C210.246 249.15 208.708 249.369 206.865 249.632C209.82 255.098 212.651 260.334 215.608 265.804C214.148 266.173 212.839 266.504 211.104 266.943C214.222 272.009 217.257 276.939 220.379 282.012C218.673 282.486 217.166 282.905 215.195 283.452C219.141 289.076 222.933 294.48 227.087 300.4H202.236V319.95H194.145V300.541H169.128C173.318 294.569 177.114 289.159 181.114 283.457Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 3.33899,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopMd);
export default __webpack_public_path__ + "static/media/desktop-md.5d57a66b9a84e76877c88400ea590048.svg";
export { ForwardRef as ReactComponent };